<template>
	<v-container fill-height fluid grid-list-xl>
		<v-layout wrap>
			<v-flex md12 sm12 lg12>
				<center>
					<v-img
						class="white--text align-end"
						height="2562px"
						max-height="256"
						max-width="400"
						width="400px"
						src="img/logo.png"
					></v-img>

					<h1>CATALOG&nbsp;&nbsp;&nbsp;</h1>
				</center>
			</v-flex>

			<v-flex md12 sm12 lg4 v-for="release in releases" :key="release.id">
				<base-card class="justify-center" color="#138dd3">
					<a :href="release.url">
						<v-img
							class="white--text align-end"
							height="2562px"
							max-height="256"
							max-width="256"
							width="256px"
							:src="release.imgsrc"
						></v-img>
					</a>

					<h4 class="title font-weight-light">{{ release.title }}</h4>
					<p class="category d-inline-flex font-weight-light">
						{{ release.releasedate }} - {{ release.subtitle }}
					</p>
				</base-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import materialCard from '~/components/material/Card';
import BaseCard from '~/components/base/Card';

export default {
	layout: 'dashboard',
	components: {
		BaseCard,
		materialCard,
	},
	data() {
		return {
			releaseData: [
				{
					id: "100",
					url: 'https://datapop1.bandcamp.com/album/ett',
					imgsrc: 'img/ett.jpg',
					title: 'ETT',
					subtitle: 'BANDCAMP, SPOTIFY, APPLE MUSIC, GOOGLE',
					releasedate: '2014-12-29',
					type: 'EP',
				},
				{
					id: "200",
					url: 'https://datapop1.bandcamp.com/album/sterne-album',
					imgsrc: 'img/sterne_cd.jpg',
					title: 'STERNE',
					subtitle: 'CD AND DIGITAL',
					releasedate: '2021-06-25',
					type: 'Album',
				},
				{
					id: "300",
					url: 'https://datapop1.bandcamp.com/album/pop',
					imgsrc: 'img/pop_cd.jpg',
					title: 'POP',
					subtitle: 'CD AND DIGITAL',
					releasedate: '2016-12-16',
					type: 'Album',
				},
				{
					id: "400",
					url: 'https://datapop1.bandcamp.com/album/rhythmus-remixed',
					imgsrc: 'img/rhythmus_remixed.jpg',
					title: 'RHYTHMUS REMIXED',
					subtitle: 'BANDCAMP, SPOTIFY, APPLE MUSIC, GOOGLE',
					releasedate: '2015-05-21',
					type: 'EP',
				},
				{
					id: "500",
					url: 'https://datapop1.bandcamp.com/track/rhythmus-remodulation-mix',
					imgsrc: 'img/rhythmus_remodelation.jpg',
					title: 'RHYTHMUS REMODULATION',
					subtitle: 'BANDCAMP',
					releasedate: '2016-01-12',
					type: 'Single',
				},
				{
					id: "600",
					url: 'https://open.spotify.com/album/5G2V0rWjFOPMLTTLJwTuao',
					imgsrc: 'img/sterne_1.png',
					title: 'STERNE - I',
					subtitle: 'EP - DIGITAL STREAMING',
					releasedate: '2019-12-31',
					type: 'EP',
				},
				{
					id: "700",
					url: 'https://open.spotify.com/album/5LqKu8JbpIUGzXpsz43sfz',
					imgsrc: 'img/sterne_2.png',
					title: 'STERNE - II',
					subtitle: 'EP - DIGITAL STREAMING',
					releasedate: '2019-12-31',
					type: 'EP',
				},
				{
					id: "800",
					url: 'https://plonk.bandcamp.com/track/rhythmus',
					imgsrc: "img/wearemachine.jpg",
					title: 'RHYTHMUS',
					subtitle: 'PLONK - WE ARE MACHINE POP. DATAPOP PLONK VERSION',
					releasedate: '2014-12-01',
					type: 'Compilation album',
				},
				{
					id: "900",
					url: 'https://plonk.bandcamp.com/album/we-are-machine-pop-2',
					imgsrc: "img/wamp2.jpg",
					title: 'MACHINE-POP MUSIC',
					subtitle: 'PLONK - WE ARE MACHINE POP 2.',
					releasedate: '2015-11-05',
					type: 'Compilation album',
				},
				{
					id: "1000",
					url: 'https://plonk.bandcamp.com/track/computer-pop',
					imgsrc: "img/wamp3.jpg",
					title: 'COMPUTER-POP',
					subtitle: 'PLONK - WE ARE MACHINE POP 3.',
					releasedate: '2016-12-01',
					type: 'Compilation album',
				}				
				,
				{
					id: "1100",
					url: 'https://plonk.bandcamp.com/track/radioklang',
					imgsrc: "img/wamp4.jpg",
					title: 'RADIOKLANG',
					subtitle: 'PLONK - WE ARE MACHINE POP 4.',
					releasedate: '2017-12-01',
					type: 'Compilation album',
				},
								
				{
					id: "1101",
					url: 'https://plonk.bandcamp.com/track/computerkrieg',
					imgsrc: "img/wamp5.jpg",
					title: 'COMPUTER KRIEG',
					subtitle: 'PLONK - WE ARE MACHINE POP 5.',
					releasedate: '2018-12-01',
					type: 'Compilation album',
				},
				{
					id: "1200",
					url: 'https://plonk.bandcamp.com/album/we-are-machine-pop-6-in-memory-of-florian-schneider',
					imgsrc: "img/wamp6.jpg",
					title: 'KLING ODER KLANG',
					subtitle: 'PLONK - WE ARE MACHINE POP 6 - IN MEMORY OF Florian Schneider.',
					releasedate: '2020-06-30',
					type: 'Compilation album',
				},
				{
					id: "1300",
					url: 'https://open.spotify.com/track/7xKK7xOtc3xcZX49wZt9Vc',
					imgsrc: "img/page_aska.jpg",
					title: 'PANIK',
					subtitle: 'PAGE - PANIK. DATAPOP REDUX',
					releasedate: '2020-12-18',
					type: 'EP',

				},
				{
					id: "1400",
					url: 'https://open.spotify.com/album/537YqqUaNLZ4IJF45NziIO',
					imgsrc: "img/kretz.png",
					title: 'FEAR ME (i am the dictator)',
					subtitle: 'KRETZ - GEMEINSCHAFTS INFORMATIONEN. DATAPOP - REMIX',
					releasedate: '2015-05-08',
					type: 'EP',
					
				},
				{
					id: "1500",
					url: 'https://neon5.bandcamp.com/album/eurostar-the-remixes',
					imgsrc: "img/neon_eurostar.png",
					title: 'EUROPA STERN',
					subtitle: 'NEON ELECTRO - EUROSTAR THE REMIXES. DATAPOP - REMAKE',
					releasedate: '2016-03-31',
					type: 'EP',
				}	,
				
				{
					id: "1600",
					url: "https://datapop1.bandcamp.com/track/kretz-mechanical-men-datapop-remix",
					imgsrc: "img/kretz_mechanical.jpg",
					title: 'MECHANICAL MEN',
					subtitle: 'KRETZ - MECHANICAL MEN. DATAPOP REMIX',
					releasedate: '2018-02-20',
					type: 'EP',
				},
				{
					id: "1700",
					url: "https://maschinebrennt.bandcamp.com/track/man-or-machine-datapop-remix",
					imgsrc: "img/bionicremix.jpg",
					title: 'MAN OR MACHINE',
					subtitle: 'MASCHINE BRENNT - MAN OR MACHINE. DATAPOP REMIX',
					releasedate: '2014-12-14',
					type: 'EP',
				},
				
				{
					id: "1800",
					url: "https://alfamatrix.bandcamp.com/track/heliograph-datapops-sunwriting",
					imgsrc: "img/heliograph.jpg",
					title: 'HELIOGRAPH',
					subtitle: 'METROLAND-HELIOGRAPH. DATAPOP REMIX',
					releasedate: "2018-09-15",
					type: 'EP',
				},
				
				{
					id: "1900",
					url: "https://alfamatrix.bandcamp.com/track/das-m-dchen-aus-dem-all-datapop-remix",
					imgsrc: "img/dasmadchen.jpg",
					title: 'DAS MÄDCHEN AUS DEM ALL',
					subtitle: 'RECTOR SCANNER - DAS MÄDCHEN AUS DEM ALL',
					releasedate: "2021-11-05",
					type: 'EP',
				}				
			],
		};
	},
	computed: {
		ctransparent() {
			return rgba(254, 254, 254, 1);
		},

		releases() {
			let sortedReleases = this.releaseData;

			let sortedReleases2 = sortedReleases.sort((a, b) => {
				if (Date.parse(a.releasedate) < Date.parse(b.releasedate)) return -1;
				if (Date.parse(a.releasedate) > Date.parse(b.releasedate)) return 1;
				if (Date.parse(a.releasedate) == Date.parse(b.releasedate)) return 0;
			});
			return sortedReleases2;
		},
	},

	mounted() {
		this.$nextTick(() => {});
	},
};
</script>
 